import {CreateTreeNode} from "../view-model";

export const findPathToNode = <T extends CreateTreeNode<T>>(
  node: T,
  caId: string,
  path: T[] = []
): T[] => {
  // If the current node is the target, return a path with the current node
  if (node.caId === caId) {
    return [...path, node];
  }

  // Check children recursively
  for (const child of node.children) {
    const foundPath = findPathToNode<T>(child, caId, [...path, node]);
    if (foundPath.length > 0) {
      return foundPath;
    }
  }
  return [];
};
